import { noop } from 'lodash'

export const VoidFunction = () => noop
